import * as d3 from 'd3';

export class AVIColorScales {
  // Default color for values that don't fit in scale
  static unknownColor = 'blue';

  /**
   * Ship category, highest level
   */
  static shipCategory = d3
    .scaleOrdinal()
    .domain([
      'Tankskip',
      'Offshorefartøy og spesialfartøy',
      'Lasteskip',
      'Fiskefartøy',
      'Passasjerskip',
      'Ukjent'
    ])
    .range(['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17'])
    .unknown(AVIColorScales.unknownColor);

  /**
   * Ship group, second level (NSR, norsk)
   */
  static shipTypeNor = d3
    .scaleOrdinal()
    .domain(['Auxiliary', 'Last', 'Fisk', 'Passasjer', 'Tank', 'Slep', 'Ukjent'])
    .range(['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17'])
    .unknown(AVIColorScales.unknownColor);

  /**
   * Ship group, second level (NSR, engelsk)
   */
  static shipType = d3
    .scaleOrdinal()
    .domain(['Auxiliary', 'Cargo', 'Fish', 'Passenger', 'Tanker', 'Tug', 'Ukjent'])
    .range(['#7fc97f', '#beaed4', '#fdc086', '#ffff99', '#386cb0', '#f0027f', '#bf5b17'])
    .unknown(AVIColorScales.unknownColor);
}
